var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{class:[_vm.$style.root, _vm.type === 'primary' && _vm.$style.isPrimary],on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('el-input',{class:_vm.$style.input,attrs:{"placeholder":_vm.placeholder,"value":_vm.value,"clearable":""},on:{"input":value => {
        _vm.$emit('input', value)
      },"clear":() => {
        _vm.$emit('input', '')
        _vm.$emit('submit')
      }}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-search","native-type":"submit"},slot:"append"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }